// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';
import {
  Box,
  Link,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';

const CfRegionalDeployStep = () => {
  return (
    <SpaceBetween size="m">
      <Box>
        <TextContent>
          <h3>Regional Resources</h3>
          <p>
            The regional resources template creates the following resources in
            each target region:
          </p>
          <ul>
            <li>
              <strong>AggregationAuthorization</strong> — Allows ResourceLens to
              aggregate Config data for each region
            </li>
            <li>
              <strong>AWS Config resources</strong> — Enables Config recording
              if not already active (only if not using a NAWS Account)
            </li>
          </ul>
        </TextContent>
      </Box>
      <Box>
        <TextContent>
          <h3>Deployment Instructions</h3>
          <ol>
            <li>
              For each target region, create a new CloudFormation stack
            </li>
            <li>Use the Regional Resources template</li>
            <li>
              Deploy the stack in each region where you want ResourceLens
              discovery
            </li>
          </ol>
        </TextContent>
      </Box>
      <Box>
        <TextContent>
          <h3>Multi-Account/Region Deployment</h3>
          <p>
            For deploying across multiple accounts and regions, consider using{' '}
            <Link
              external
              href="https://docs.aws.amazon.com/AWSCloudFormation/latest/UserGuide/stacksets-concepts.html"
            >
              AWS CloudFormation StackSets
            </Link>{' '}
            for centralized deployment.
          </p>
        </TextContent>
      </Box>
    </SpaceBetween>
  );
};

export default CfRegionalDeployStep;
